<script setup>
import { computed } from "vue";
import { associates, siteCopy } from "../data/content";
import IconArrow from "../components/IconArrow.vue";
import SiteFooter from "../components/SiteFooter.vue";
import SiteHeader from "../components/SiteHeader.vue";

const props = defineProps({
  locale: { type: String, required: true },
});

const site = computed(() => siteCopy[props.locale]);
const copy = computed(() => site.value.associated);
const names = ["Hefesto", "Atenea", "Apolo", "Hermes"];
</script>

<template>
  <div class="site-page inner-page" :lang="locale">
    <SiteHeader :locale="locale" :nav="site.nav" path="/associates" />
    <main id="main">
      <section class="page-hero page-hero--associates">
        <div class="shell">
          <p class="eyebrow">{{ copy.kicker }}</p>
          <h1>{{ copy.title }}</h1>
          <p>{{ copy.description }}</p>
          <a class="button button--primary associates-hero__cta" href="#associated-services">
            {{ copy.explore }}<IconArrow />
          </a>
        </div>
      </section>

      <section id="associated-services" class="section associates-section">
        <div class="shell associate-grid">
          <article
            v-for="(associate, index) in associates"
            :key="associate.index"
            :class="`associate-card associate-card--${associate.accent}`"
            data-reveal
          >
            <div class="associate-card__number">
              <span>{{ associate.index }}</span>
              <small>{{ names[index] }}</small>
            </div>
            <div class="associate-card__symbol" aria-hidden="true"><span /><span /><span /></div>
            <h2>{{ associate.title[locale] }}</h2>
            <p>{{ associate.description[locale] }}</p>
            <a
              class="inline-link"
              :href="`mailto:resicorporation@gmail.com?subject=${encodeURIComponent(associate.title[locale])}`"
            >
              {{ copy.request }}<IconArrow />
            </a>
          </article>
        </div>
      </section>
    </main>
    <SiteFooter :locale="locale" :copy="site.footer" />
  </div>
</template>
